// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"ee23dc69","132":"36244b46","419":"87d18be4","563":"a05c3170","787":"95ac91b5","850":"e16b053f","942":"6a243bf7"}[chunkId] + ".chunk.js";
};